import React, { useState } from 'react';
import TruncateText from './TruncateText';
import './KidsCard.scss'
import { useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
// Define the types for the props
interface KidsCardProps {
    thumbnailUrl: string;
    gifUrl: string;
    title: string;
    description?: string;
    duration: string;
    onClick: () => void
}

const KidsCard: React.FC<KidsCardProps> = ({
    thumbnailUrl,
    gifUrl,
    title,
    description,
    duration,
    onClick
}) => {
    const claims = useSelector(getUserClaims);
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className='kids-card'
            onClick={() => {
                onClick()
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {isHovered ? (
                <img src={gifUrl} alt={title} className={`kids-card-img ${claims?.subscription ? '' : 'kids-card-desaturate-image'}`} />
            ) : (
                <img src={thumbnailUrl} alt={title} className={`kids-card-img ${claims?.subscription ? '' : 'kids-card-desaturate-image'}`} />
            )}
            <div className='kids-card-info'>
                <h3 className={`kids-card-title ${title?.length > 33 ? 'long-text' : ''}`}>{title}</h3>
                {description && <TruncateText className='kids-card-description' text={description} lineHeight={20} />}
                <span className='kids-card-duration'>{duration}</span>
            </div>
        </div>
    );
};

export default KidsCard;
